import React from "react";
import { useLanguagesContext } from "hooks/useContextAll";

const PageDirection = (props) => {
    const language = useLanguagesContext();

    return (
        <div className={language.language === "en" ? "ltr" : "rtl"}>
            {props.children}
        </div>
    );
};

export default PageDirection;
